import XesLoggerSDK from "@xes/xes_fe_log";
import { loggerConfig } from "./config";
import { objectToGetParams, param2Obj } from "./common";
import cookie from "./cookie";

export default class XesLogger {
  constructor() {
    this.pageInfo = {};
    this.logger = new XesLoggerSDK(loggerConfig);
  }

  setPageInfo(pageInfo) {
    this.pageInfo = pageInfo;
  }

  sendLog(type, content, elem) {
    let logData = {};
    content.userid = content.userid ? content.userid : cookie.get("stu_id"); // 加入默认的cookie用户信息
    const query = param2Obj(location.href);
    content = Object.assign(query, content, this.pageInfo); // 用户数据优先级高于query 默认数据
    content.type = type;
    logData.elem = elem;
    if (type === "click") {
      // 加入url query 信息
      logData.params = objectToGetParams(content);
      this.logger.clickMsg(logData);
    } else if (type === "pageLoad") {
      logData = objectToGetParams(content);
      this.logger.loadMsg(logData);
    }
  }
}
